export const formatNumber = (
  value: number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
};

export const formatPrice = (price: number, divideBy = 100, withDecimals = false) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: withDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(price / divideBy);
};
